namespace TabAurous.OMS {
    export interface CustomerForm {
        PartyType: Serenity.StringEditor;
        PartyCode: Serenity.StringEditor;
        CustomerPrefix: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        LedgerName: Serenity.StringEditor;
        AccountGroupId: Serenity.DecimalEditor;
        TermId: Serenity.IntegerEditor;
        MailingName: Serenity.StringEditor;
        Email: Serenity.EmailEditor;
        BillbyBill: Serenity.BooleanEditor;
        TaxRegType: Serenity.LookupEditor;
        GstVat: Serenity.StringEditor;
        Pan: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        LbrFlag: Serenity.BooleanEditor;
        StnFlag: Serenity.BooleanEditor;
        LbrFromDate: Serenity.DateEditor;
        LbrToDate: Serenity.DateEditor;
        StnFromDate: Serenity.DateEditor;
        StnToDate: Serenity.DateEditor;
        MarkUpPolicyId: Serenity.LookupEditor;
        Coef: Serenity.DecimalEditor;
        CostPricegroupId: Serenity.LookupEditor;
        StnAddDisc: Serenity.DecimalEditor;
        StnAddMkp: Serenity.DecimalEditor;
        LbrPricegroupId: Serenity.LookupEditor;
        LbrAddDisc: Serenity.DecimalEditor;
        LbrAddMkp: Serenity.DecimalEditor;
        AddressDetails: AddressMasterEditor;
        ContactDetails: ContactDetailsEditor;
        Token: Serenity.StringEditor;
        APIEndpoint: Serenity.StringEditor;
        APIToken: Serenity.StringEditor;
        AutoCreateVoucherUsingAPI: Serenity.BooleanEditor;
        AutoPosting: Serenity.BooleanEditor;
    }

    export class CustomerForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.Customer';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomerForm.init)  {
                CustomerForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.EmailEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DateEditor;
                var w7 = AddressMasterEditor;
                var w8 = ContactDetailsEditor;

                Q.initFormType(CustomerForm, [
                    'PartyType', w0,
                    'PartyCode', w0,
                    'CustomerPrefix', w0,
                    'IsDisabled', w1,
                    'LedgerName', w0,
                    'AccountGroupId', w2,
                    'TermId', w3,
                    'MailingName', w0,
                    'Email', w4,
                    'BillbyBill', w1,
                    'TaxRegType', w5,
                    'GstVat', w0,
                    'Pan', w0,
                    'CurrencyId', w5,
                    'LbrFlag', w1,
                    'StnFlag', w1,
                    'LbrFromDate', w6,
                    'LbrToDate', w6,
                    'StnFromDate', w6,
                    'StnToDate', w6,
                    'MarkUpPolicyId', w5,
                    'Coef', w2,
                    'CostPricegroupId', w5,
                    'StnAddDisc', w2,
                    'StnAddMkp', w2,
                    'LbrPricegroupId', w5,
                    'LbrAddDisc', w2,
                    'LbrAddMkp', w2,
                    'AddressDetails', w7,
                    'ContactDetails', w8,
                    'Token', w0,
                    'APIEndpoint', w0,
                    'APIToken', w0,
                    'AutoCreateVoucherUsingAPI', w1,
                    'AutoPosting', w1
                ]);
            }
        }
    }
}
